import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PermissionForm } from "../schema/PermissionSchema";
import { PermissionCreateResponse } from "../response/PermissionCreateResponse";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";

export const useCreatePermission = () => {
    return useMutation({
        mutationFn: async (formData: PermissionForm) => await privateApi.post(`/v3/permission`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = PermissionCreateResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid permission data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create permission', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid permission data format");
            } else {
                console.error(`Failed to create permission`, error);
                throw error;
            }
        }
    });
};